import { linkValido } from './links';

// Atalho do pedido de patrocínio aprovado para o cadastro do banner. O pedido não traz
// imagem (o banner exige uma), então o administrador cadastra o banner em Conteúdo >
// Banners; estas duas funções levam a empresa e o site do pedido para o formulário.
const MAX_NOME_BANNER = 100;
const MAX_LINK_BANNER = 100;

// Caminho do formulário de novo banner já com os dados do pedido.
export function caminhoCadastrarBanner(pedido) {
  const params = new URLSearchParams();
  if (pedido?.empresa) params.set('empresa', pedido.empresa);
  if (pedido?.link) params.set('link', pedido.link);
  // Liga o banner ao pedido: assim desabilitar o patrocinio desabilita tambem o banner.
  if (Number.isInteger(pedido?.id)) params.set('pedido', String(pedido.id));
  const texto = params.toString();
  return `/admin/conteudo/banners/novo${texto ? `?${texto}` : ''}`;
}

// Dados iniciais do NOVO banner a partir da URL (?empresa=...&link=...). São texto da
// barra de endereços — qualquer um pode editá-los —, então são limpos antes de usar: o
// nome é aparado e limitado ao tamanho do campo, e o link só entra se for http/https de
// verdade (nunca "javascript:" nem texto solto). Sem parâmetros, o formulário começa
// vazio como sempre.
export function inicialDoNovoBanner(params) {
  const empresa = String(params.get('empresa') ?? '').trim().slice(0, MAX_NOME_BANNER);
  const link = String(params.get('link') ?? '').trim();
  const pedido = String(params.get('pedido') ?? '').trim();
  return {
    ...(/^\d{1,9}$/.test(pedido) ? { solicitacao_id: Number(pedido) } : {}),
    ...(empresa ? { nome: empresa } : {}),
    ...(link && link.length <= MAX_LINK_BANNER && linkValido(link) ? { link } : {}),
  };
}
